/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { useContext } from 'react';
import { KahuFloatingDockContext } from '@/context';

/**
 * Shared anchors for floating chat UI (e.g. a list pager that docks above the
 * input when its inline copy scrolls out of view).
 *
 * - `dockEl` is the DOM node above the input that floating UI portals into.
 * - `scrollRoot` is the chat's scroll container, used as the
 *   IntersectionObserver root (the chat scrolls in its own box, not the window).
 */

export const KahuFloatingDockProvider = KahuFloatingDockContext.Provider;

export const useKahuFloatingDock = () => useContext(KahuFloatingDockContext);
